import React from 'react';
import { PrivateRoute } from '../components/PrivateRoute';
import { Menu } from '../modules/Menu';

const sandboxMenu = ({ ...props }) => {
  return <PrivateRoute location={props.location.pathname} component={Menu} />;
};

export default sandboxMenu;
